import { render, staticRenderFns } from "./AddBannerPopup.vue?vue&type=template&id=78b95a36"
import script from "./AddBannerPopup.vue?vue&type=script&lang=js"
export * from "./AddBannerPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports